interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="分页导航" className="mt-10 flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? 'page' : undefined}
          className={[
            'flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm transition-colors cursor-pointer',
            p === page
              ? 'bg-primary-600 text-background-50'
              : 'border border-background-300/70 text-foreground-700 hover:border-primary-300 hover:text-primary-700',
          ].join(' ')}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
      </button>
    </nav>
  );
}